import { useEffect } from 'react';

import { reportErrorToBugsnag } from '@air/utils-error';

import { usePendingOnboardingUploadFiles } from '~/components/WorkspaceOnboardingForm/PendingOnboardingUploadFilesProvider';
import { useSubmitOnboardingUpload } from '~/components/WorkspaceOnboardingForm/useSubmitOnboardingUpload';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

export const useSubmitPendingOnboardingUpload = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const { takePendingOnboardingUploadFiles } = usePendingOnboardingUploadFiles();
  const { submitOnboardingUpload } = useSubmitOnboardingUpload();

  useEffect(() => {
    if (!currentWorkspace?.id) {
      return;
    }

    const handoff = takePendingOnboardingUploadFiles();

    if (!handoff?.files.length) {
      return;
    }

    const targetWorkspaceId = handoff.board?.workspaceId ?? handoff.workspaceId;

    if (targetWorkspaceId !== currentWorkspace.id) {
      reportErrorToBugsnag({
        error: new Error('Pending onboarding upload workspace did not match the current workspace'),
        context: 'Refused to submit pending onboarding upload into a different workspace',
        metadata: {
          data: {
            currentWorkspaceId: currentWorkspace.id,
            handoffWorkspaceId: handoff.workspaceId,
            boardWorkspaceId: handoff.board?.workspaceId,
          },
        },
      });
      return;
    }

    void submitOnboardingUpload({
      acceptedFiles: handoff.files,
      board: handoff.board,
      category: 'agent_onboarding',
      skipBoardCreation: handoff.skipBoardCreation,
    }).catch((error: unknown) => {
      reportErrorToBugsnag({
        error,
        context: 'Failed to submit pending onboarding upload',
        metadata: { data: { workspaceId: currentWorkspace.id } },
      });
    });
  }, [currentWorkspace?.id, submitOnboardingUpload, takePendingOnboardingUploadFiles]);
};
